<template>
  <div>
  <div v-if="!loading">
    <v-container grid-list-md fluid class="ma-0 pa-0 pb-3">
      <v-layout row wrap >
        <CompanySelector @dataChanged="loadSettings()"/>
        <v-flex xs6 class="text-right">
          <v-btn :disabled="!changed" depressed  :dark="changed" @click="saveSettings" :color="companyPrimaryColor">
            <span v-if="!changed">Opgeslagen</span>
            <span v-else class="white--text">Opslaan</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
   
    <v-container grid-list-md class="px-0 pt-0 align-center" fluid>
      <v-layout row wrap>
        <v-flex md6 xs12 d-flex >
          <v-card outlined style="width: 100%; overflow: hidden;">
            <div class="pa-4 pt-2">
              <h1 class="tab-title">Instellingen</h1>
              <v-switch
               label="Qcare actief"
               v-model="qcareSettings.active"
              > 
              </v-switch>
              <v-alert dense  v-if="!qcareSettings.active" type="info" ><span style="font-size: 14px; color: white">Wanneer Qcare niet actief is, zal deze optie nooit voorgesteld worden.</span></v-alert>
              <v-alert dense  v-else type="info" ><span style="font-size: 14px; color: white">Wanneer Qcare actief is, zal deze optie voorgesteld aan de hand van de instellingen en tijden.</span></v-alert>

              <div v-if="qcareSettings.active">       
                <v-select
                  class="mt-4"
                  hide-details
                  outlined
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  v-model="qcareSettings.useByQueueLength"
                  :items="callBackSuggestionOptions"
                  label="Wanneer terugbellen voorstellen?"
                  ackground-color="background"
                  item-text="name"
                  item-value="id"
                ></v-select> 

                <v-select
                  class="mt-4"
                  hide-details
                  outlined
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  v-model="qcareSettings.timeBlock"
                  :items="timeBlocksOptions"
                  label="Tijdblokken voor Qcare"
                  ackground-color="background"
                  item-text="name"
                  item-value="id"
                ></v-select> 

                <v-select
                  class="mt-4"
                  hide-details
                  outlined
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  v-model="qcareSettings.daysInFuture"
                  :items="daysAheadOptions"
                  label="Hoe ver in de toekomst terugbeltijden voorstellen?"
                  ackground-color="background"
                  item-text="name"
                  item-value="id"
                ></v-select> 

                <v-select
                  class="mt-4"
                  hide-details
                  outlined
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  v-model="qcareSettings.maxNumberToShow"
                  :items="maxNumberToShowOptions"
                  label="Hoeveel terugbeltijden voorstellen?"
                  ackground-color="background"
                  item-text="name"
                  item-value="id"
                ></v-select> 
              </div>
            </div>
            <div class="pa-4 pt-2 pb-0" v-if="qcareSettings.active">
              <h3 style="font-weight: bold;">Qcare actief tijden</h3>
              <p class="mb-0"><i>Wanneer wordt Qcare voorgesteld?</i></p>

              <v-switch
               label="Altijd voorstellen als er aan de voorwaarden voldaan is"
               v-model="qcareSettings.alwaysUseQcare"
              > 
              </v-switch>

            </div>
            <div v-if="!qcareSettings.alwaysUseQcare && qcareSettings.active">
              <v-container class="pa-0 ma-0">
                <p class="mb-0 pl-3 pt-4"><i>Qcare alleen voorstellen op onderstaande dagen en tijden.</i></p>
                  <v-row row wrap class="table-header">
                    <v-col cols="3" class="pl-6"><strong> Dag</strong></v-col>
                    <v-col cols="3"></v-col>
                    <v-col cols="6">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <strong>Start</strong>
                        </v-col>
                        <v-col cols="5">
                          <strong>Eind</strong>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row row wrap class="pa-0 ma-0 align-center" v-for="(key, index) in Object.keys(days)" :key="index + timeChanges" :class="{'row-even': index % 2 == 0, 'row-odd': index % 2 == 1}">
                    <v-col cols="3" class="pt-3">{{days[key]}}</v-col>
                    <v-col cols="3" class="branch-day-active pt-3">
                      <v-switch color="primary" class="ma-0 pa-0" v-model="qcareSettings.activeSchedule[key].active" hide-details></v-switch>
                    </v-col>
                    <v-col cols="6" class="branch-start-hours text-center" v-if="qcareSettings.activeSchedule[key].active == true" >
                      
                      <v-row v-for="(time, index) in qcareSettings.activeSchedule[key].times" :key="index" class="pa-0 my-0 d-flex align-center" no-gutters>
                        <v-col cols="5">
                          <v-text-field color="primary" type="time" outlined dense hide-details class="ma-1 pa-0" v-model="time.start" ></v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-text-field color="primary" type="time" outlined dense hide-details class="ma-1 pa-0" v-model="time.end" ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-btn fab x-small icon depressed color="primary" @click="removeTime('activeSchedule', key, index)"><v-icon>mdi-delete</v-icon></v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0 my-0 d-flex align-center">
                        <v-col cols="10" class="pa-0">
                          <v-btn fab x-small outlined depressed color="primary" class="mt-1" @click="addTime('activeSchedule', key)"><v-icon>mdi-plus</v-icon></v-btn>
                        </v-col>
                      </v-row>


                    </v-col>
                  </v-row>
                  
              </v-container>
            </div>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <v-card outlined style="width: 100%; overflow: hidden;">
            <div class="pa-4 pt-2 pb-0">
              <h1 class="tab-title">Qcare terugbel tijden</h1>
              <p class="mb-0"><i>Wanneer kan een client terugbellen?</i></p>
            </div>
            <div>
              <v-container class="pa-0 ma-0">
                  <v-row row wrap class="table-header">
                    <v-col cols="3" class="pl-6"><strong> Dag</strong></v-col>
                    <v-col cols="3"></v-col>
                    <v-col cols="6">
                      <v-row no-gutters>
                        <v-col cols="5">
                          <strong>Start</strong>
                        </v-col>
                        <v-col cols="5">
                          <strong>Eind</strong>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row row wrap class="pa-0 ma-0 align-center" v-for="(key, index) in Object.keys(days)" :key="index" :class="{'row-even': index % 2 == 0, 'row-odd': index % 2 == 1}">
                    <v-col cols="3" class="pt-3">{{days[key]}}</v-col>
                    <v-col cols="3" class="branch-day-active pt-3">
                      <v-switch color="primary" class="ma-0 pa-0" v-model="qcareSettings.callBackSchedule[key].active" hide-details></v-switch>
                    </v-col>
                    <v-col cols="6" class="branch-start-hours text-center" v-if="qcareSettings.callBackSchedule[key].active == true" >
                      
                      <v-row v-for="(time, index) in qcareSettings.callBackSchedule[key].times" :key="index" class="pa-0 my-0 d-flex align-center" no-gutters>
                        <v-col cols="5">
                          <v-text-field color="primary" type="time" outlined dense hide-details class="ma-1 pa-0" v-model="time.start" ></v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-text-field color="primary" type="time" outlined dense hide-details class="ma-1 pa-0" v-model="time.end" ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-btn fab x-small icon depressed color="primary" @click="removeTime('callBackSchedule', key, index)"><v-icon>mdi-delete</v-icon></v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="pa-0 my-0 d-flex align-center">
                        <v-col cols="10" class="pa-0">
                          <v-btn fab x-small outlined depressed color="primary" class="mt-1" @click="addTime('callBackSchedule', key)"><v-icon>mdi-plus</v-icon></v-btn>
                        </v-col>
                      </v-row>


                    </v-col>
                  </v-row>
                  
              </v-container>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md class="px-0 pt-0 align-center" fluid>
      <v-layout row wrap>
        <v-flex md6 xs12 d-flex>
          <v-card outlined style="width: 100%">
            <v-row class="py-0 my-0 px-4 align-center" no-gutters>
              <v-col cols="8">
                <h1 class="tab-title">Extra terugbel tijden</h1>
              </v-col>
              <v-col cols="4" class="text-right">
                <v-btn fab x-small outlined depressed color="primary" class="mt-1" @click="showExtraPresenceModal('present')"><v-icon>mdi-plus</v-icon></v-btn>
              </v-col>
            </v-row> 
              
            <v-divider/>
            <div class="pa-2">
              <v-btn-toggle v-model="extraPresentType" style="width: 100%;" class="pa-0 ma-0">
                <v-btn style="width: 50%;" value="past" color="primary" :outlined="extraPresentType == 'future'">
                  <span :style="{color: extraPresentType == 'past' ? 'white' : 'black'}">Verleden</span>
                </v-btn>

                <v-btn style="width: 50%;" value="future" color="primary" :outlined="extraPresentType == 'past'" dark>
                  <span :style="{color: extraPresentType == 'future' ? 'white' : 'black'}">Toekomst</span>
                </v-btn>
              </v-btn-toggle>
            </div>

            <v-divider/>
            <v-data-table
              v-if="extraPresentScheduleFiltered.length > 0"
              :headers="extraTimesHeaders"
              :items="extraPresentScheduleFiltered"
              hide-default-footer
            >
            <template v-slot:item="{item, index}">
            <tr>
              <td>{{formatDate(item.start, 'D MMMM YYYY')}}</td>
              <td><v-chip small color="#eeeeee" v-for="(time, index) in item.times" :key="index">{{time.start}} - {{time.end}}</v-chip></td>
              <td>{{item.extra}}</td>
              <td class="text-right">
                <v-btn icon @click="removeExtraPresence('present', item.id)"><v-icon size="20">mdi-delete</v-icon></v-btn>
              </td>
            </tr>
            </template>
          </v-data-table>

            <div v-else class="py-4 text-center">
              <p class="pa-4 pt-0 pb-0">Geen extra terugbel tijden gevonden.</p>
            </div>
           
          </v-card>
        </v-flex>
        <v-flex md6 xs12 d-flex>

          <v-card outlined style="width: 100%">
            <v-row class="py-0 my-0 px-4 align-center" no-gutters>
              <v-col cols="8">
                <h1 class="tab-title">Extra afwezig terugbel tijden</h1>
              </v-col>
              <v-col cols="4" class="text-right">
                <v-btn fab x-small outlined depressed color="primary" class="mt-1" @click="showExtraPresenceModal('absent')"><v-icon>mdi-plus</v-icon></v-btn>
              </v-col>
            </v-row> 
              
            <v-divider/>

            <div class="pa-2">
              <v-btn-toggle v-model="extraAbsentType" style="width: 100%;" class="pa-0 ma-0">
                <v-btn style="width: 50%;" value="past" color="primary" :outlined="extraAbsentType == 'future'">
                  <span :style="{color: extraAbsentType == 'past' ? 'white' : 'black'}">Verleden</span>
                </v-btn>

                <v-btn style="width: 50%;" value="future" color="primary" :outlined="extraAbsentType == 'past'" dark>
                  <span :style="{color: extraAbsentType == 'future' ? 'white' : 'black'}">Toekomst</span>
                </v-btn>
              </v-btn-toggle>
            </div>

            <v-divider/>

            <v-data-table
              v-if="extraAbsentScheduleFiltered.length > 0"
              :headers="extraTimesHeaders"
              :items="extraAbsentScheduleFiltered"
              hide-default-footer
            >
            <template v-slot:item="{item, index}">
            <tr>
              <td>
                <span v-if="item.period"> 
                  <span v-if="formatDate(item.start, 'MM') == formatDate(item.end, 'MM')"> {{formatDate(item.start, 'D')}} t/m {{formatDate(item.end, 'D MMMM YYYY')}}</span>
                  <span v-else> {{formatDate(item.start, 'D MMMM YYYY')}} t/m {{formatDate(item.end, 'D MMMM YYYY')}}</span>
                </span>
                <span v-else> {{formatDate(item.start, 'D MMMM YYYY')}}</span>

              </td>
              <td>
                <div v-if="item.allDay">
                  <v-chip color="#eeeeee" small dark>Volledige dag</v-chip>
                </div>
                <div v-else>
                  <v-chip color="#eeeeee" small dark v-for="(time, index) in item.times" :key="index">{{time.start}} - {{time.end}}</v-chip>
                </div>
              </td>
              <td>{{item.extra}}</td>
              <td class="text-right">
                <v-btn icon @click="removeExtraPresence('absent', item.id)"><v-icon size="20">mdi-delete</v-icon></v-btn>
              </td>
            </tr>
            </template> 
          </v-data-table>

            <div v-else class="py-4 text-center">
              <p class="pa-4 pt-0 pb-0">Geen extra afwezig terugbel tijden gevonden.</p>
            </div>
           
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  <div v-else>
    <v-progress-circular indeterminate color="companyPrimaryColor" class="ma-10 text-center"></v-progress-circular>
  </div>

  <v-dialog v-model="presenceModal.dialog" max-width="500">
    <v-card>
      <v-card-title>
        <h2 v-if="presenceModal.type == 'present'">Extra terugbel tijden</h2>
        <h2 v-if="presenceModal.type == 'absent'">Extra afwezig terugbel tijden</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeExtrapresenceModal"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <div v-if="presenceModal.type == 'absent'">
          <v-switch v-model="presenceModal.period" @change="presenceModal.end = null" label="Periode"></v-switch>
        </div>
        <v-row no-gutters>
          <v-col cols="6">
            <v-menu close-on-content-click>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined dense hide-details :label="presenceModal.period ? 'Startdatum' : 'Datum'" class="pr-1" v-model="presenceModal.start" v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" no-title v-model="presenceModal.start" class="mt-4"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" v-if="presenceModal.period">
            <v-menu close-on-content-click>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined dense hide-details label="Einddatum"  class="pl-1" v-model="presenceModal.end" v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" no-title v-model="presenceModal.end" class="mt-4"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <div v-if="presenceModal.type == 'absent'">
          <v-switch v-model="presenceModal.allDay" @change="presenceModal.times = []" label="Volledige dag"></v-switch>
        </div>
        <div v-if="!presenceModal.allDay">    
          <div class="pt-3">
            <strong>Tijden</strong>
          </div>
          <v-row no-gutters v-for="(time, index) in presenceModal.times" :key="index" class="pa-0 py-2 my-0 d-flex align-center">
            <v-col cols="5">
              <v-text-field type="time" outlined dense hide-details label="Start" v-model="time.start"></v-text-field>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="5">
              <v-text-field type="time" outlined dense hide-details label="Eind" v-model="time.end"></v-text-field>
            </v-col>
            <v-col cols="1" class="text-center">
              <v-btn icon @click="removePresenceTime(index)"><v-icon size="20">mdi-delete</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="11" class="text-center pt-3">
              <v-btn fab x-small depressed color="primary" @click="addPresenceTime()"><v-icon >mdi-plus</v-icon></v-btn>
            </v-col>
          </v-row>
        </div>
        <div>
          <v-row no-gutters>
            <v-col cols="12" class="text-center pt-5">
              <v-text-field  outlined dense hide-details label="Extra" v-model="presenceModal.extra"></v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container class="pa-1 ma-0 px-2">
          <v-row no-gutters>
            <v-col cols="6">
              <v-btn color="text" outlined @click="closeExtrapresenceModal">Annuleren</v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn color="primary" :disabled="!validatePresenceModal()" @click="saveExtraPresent">Opslaan</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    
  </v-dialog>
  </div>
</template>


<script>

import db from "../firebase/init";
import CompanySelector from "../components/elements/CompanySelector.vue";
import moment from 'moment/min/moment-with-locales';
import 'moment/locale/nl';

export default {
  name: "QcareSettings",
  components: {
    CompanySelector
  },
  data: () => ({
    loading: true,
    days: {
      Sun: "Zondag",
      Mon: "Maandag",
      Tue: "Dinsdag",
      Wed: "Woensdag",
      Thu: "Donderdag",
      Fri: "Vrijdag",
      Sat: "Zaterdag"
    },
    timeChanges:0,
    qcareSettings: {
      
    },
    extraAbsentType:'future',
    extraPresentType:'future',
    presenceModal: {
      dialog: false,
      type: "present"
    },
    qcareSettingsOriginal: {},
    extraPresentSchedule: [],
    extraAbsentSchedule: [],
    extraTimesHeaders: [
      {
        text: 'Dag',
        value: 'day',
        width: '300px'
      },
      {
        text: 'Tijden',
        value: 'times',
        width: '200px'
      },
      {
        text: 'Extra',
        value: 'extra'
      },
      {
        text: '',
        value: 'action'
      }
    ],
    timeBlocksOptions: [
      {
        id: 5,
        name: '5 minuten'
      },
      {
        id: 10,
        name: '10 minuten'
      },
      {
        id: 15,
        name: '15 minuten'
      },
      {
        id: 20,
        name: '20 minuten'
      }
    ],
    maxNumberToShowOptions: [
        {
          id: 5,
          name: '5 opties'
        },
        {
          id: 10,
          name: '10 opties'
        },
        {
          id: 15,
          name: '15 opties'
        },
    ],
    daysAheadOptions: [
      {
        id: 1,
        name: '1 - Alleen opties voor huidige dag geven'
      },
      {
        id: 2,
        name: '2 - Opties voor huidige dag en de komende dag geven'
      },
      {
        id: 3,
        name: '3 - Opties voor huidige dag, de komende 2 dagen geven'
      },
      {
        id: 4,
        name: '4 - Opties voor huidige dag, de komende 3 dagen geven'
      },
      {
        id: 5,
        name: '5 - Opties voor huidige dag, de komende 4 dagen geven'
      }
    ],
    callBackSuggestionOptions: [
      {
        id: 0,
        name: 'Altijd'
      },
      {
        id: 1,
        name: 'Bij 1 of meer personen in de huidige wachtrij'
      },
      {
        id: 2,
        name: 'Bij 2 of meer personen in de huidige wachtrij'
      },
      {
        id: 3,
        name: 'Bij 3 of meer personen in de huidige wachtrij'
      },
      {
        id: 4,
        name: 'Bij 4 of meer personen in de huidige wachtrij'
      },
      {
        id: 5,
        name: 'Bij 5 of meer personen in de huidige wachtrij'
      }
    ]
  }),

  created() {
    this.loadSettings();
  },

  methods: {
    async loadSettings() {
      this.loading = true;
      if(this.$store.state.activeBranchData.qcare && this.$store.state.activeBranchData.qcare.activeSchedule){
        this.qcareSettings = JSON.parse(JSON.stringify(this.$store.state.activeBranchData.qcare));
      }
      else{
        this.setDefaultQcareSettings()
      }
      this.extraPresentSchedule = [];
      this.extraAbsentSchedule = [];
      this.qcareSettingsOriginal = JSON.parse(JSON.stringify(this.qcareSettings));
      this.loading = false;


      // load extra presence schedule
      db.collection("branches", ).doc(this.$store.state.activeBranchData.id).collection("qcareScheduleExceptions").get().then(snapshot => {
        snapshot.forEach(doc => {
        if(doc.data().type == 'present'){
        this.extraPresentSchedule.push({
          id: doc.id,
          start: doc.data().start,
          end: doc.data().end,
          period: doc.data().period,
          allDay: doc.data().allDay,
          times: doc.data().times,
          extra: doc.data().extra
          });
        }
        else{
          this.extraAbsentSchedule.push({
            id: doc.id,
            start: doc.data().start,
            end: doc.data().end,
            period: doc.data().period,
            allDay: doc.data().allDay,
            times: doc.data().times,
            extra: doc.data().extra
          });
          }
        });
      });
    },

    /**
     * Set default qcare settings with default objects and arrays
     */
    setDefaultQcareSettings(){
      this.qcareSettings = {
        active: false,
      alwaysUseQcare: true,
      activeSchedule: {
        Sun: {
          active: false,
          times: []
        },
        Mon: {
          active: false,
          times: []
        },
        Tue: {
          active: false,
          times: []
        },
        Wed: {
          active: false,
          times: []
        },
        Thu: {
          active: false,
          times: []
        },
        Fri: {
          active: false,
          times: []
        },
        Sat: {
          active: false,
          times: []
        },
      },
      callBackSchedule: {
        Sun: {
          active: false,
          times: []
        },
        Mon: {
          active: false,
          times: []
        },
        Tue: {
          active: false,
          times: []
        },
        Wed: {
          active: false,
          times: []
        },
        Thu: {
          active: false,
          times: []
        },
        Fri: {
          active: false,
          times: []
        },
        Sat: {
          active: false,
          times: []
        },
      },
      timeBlock: 5,
      daysInFuture: 2,
      maxNumberToShow: 5,
      useByQueueLength: 0
      };
    },

    /**
     * Save qcare settings to firebase
     */
    async saveSettings() {
      this.loading = true;
      await db.collection("branches").doc(this.$store.state.activeBranchData.id).update({
        qcare: this.qcareSettings
      });
      this.qcareSettingsOriginal = JSON.parse(JSON.stringify(this.qcareSettings));
      this.loading = false;
    },

    /**
     * Add time to qcare settings
     * @param type - type of time (present or absent)
     * @param day - day of the week
     */
    addTime(type, day){
      if(!this.qcareSettings[type][day].times){
        this.qcareSettings[type][day].times = [];
      }
      this.qcareSettings[type][day].times.push({
        start: "09:00",
        end: "17:00"
      });
      this.timeChanges++;
    },
    /**
     * Remove time from qcare settings
     * @param type - type of time (present or absent)
     * @param day - day of the week
     * @param index - index of the time to remove
     */
    removeTime(type, day, index){
      this.qcareSettings[type][day].times.splice(index, 1);
      this.timeChanges++;
    },

    /**
     * Show extra presence modal
     * @param type - type of time (present or absent)
     */
    showExtraPresenceModal(type){
      this.presenceModal = {
        dialog: true,
        type: type,
        allDay: type == 'absent' ? true : false,
        period: false,
        start: null,
        end: null,
        extra: null,
        times: type == 'absent'? [] : [
          {
            start: null,
            end: null
          }
        ]
      };
    },
    /**
     * Close extra presence modal
     */
    closeExtrapresenceModal(){
      this.presenceModal = {
        dialog: false,
        type: "present",
        allDay: false,
        period: false,
        start: null,
        end: null,
        extra: null,
        times: [
          {
            start: null,
            end: null
          }
        ]
      };
    },

    /**
     * Save extra presence (present or absent) to branch subcollection in firebase
     */
    async saveExtraPresent(){
      // add doc to subcollection
      const docRef = await db.collection("branches", ).doc(this.$store.state.activeBranchData.id).collection("qcareScheduleExceptions").add({
        start: this.presenceModal.start,
        end: this.presenceModal.end ? this.presenceModal.end : this.presenceModal.start,
        period: this.presenceModal.period,
        type: this.presenceModal.type,
        times: this.presenceModal.times,
        allDay: this.presenceModal.allDay,
        extra: this.presenceModal.extra,
        createdAt: new Date()
      });

      if(this.presenceModal.type == 'present'){
        this.extraPresentSchedule.push({
          start: this.presenceModal.start,
          end: this.presenceModal.start,
          type: this.presenceModal.type,
          allDay: this.presenceModal.allDay,
          times: this.presenceModal.times,
          extra: this.presenceModal.extra,
          id: docRef.id
        });
      }
      else{
        this.extraAbsentSchedule.push({
          start: this.presenceModal.start,
          end: this.presenceModal.end ? this.presenceModal.end : this.presenceModal.start,
          type: this.presenceModal.type,
          allDay: this.presenceModal.allDay,
          times: this.presenceModal.times,
          period: this.presenceModal.period,
          extra: this.presenceModal.extra,
          id: docRef.id
        });
      }

      this.closeExtrapresenceModal();
    },

    /**
     * Add extra time to presence modal
     */
    addPresenceTime(){
      this.presenceModal.times.push({
        start: null,
        end: null
      });
    },

    /**
     * Remove time from presence modal
     * @param index - index of the time to remove
     */
    removePresenceTime(index){  
      this.presenceModal.times.splice(index, 1);
    },

    /**
     * Validate presence modal (check if all fields are filled and if the times are valid)
     */
    validatePresenceModal(){
      let valid = true;
      if(this.presenceModal.period){
        if(!this.presenceModal.start || !this.presenceModal.end){
          valid = false;
        }
      }

      if(this.presenceModal.start && (!this.presenceModal.allDay && this.presenceModal.times.length > 0)){
        for(let i = 0; i < this.presenceModal.times.length; i++){
          if(this.presenceModal.times[i].start == null || this.presenceModal.times[i].end == null || this.presenceModal.times[i].start.length < 4 || this.presenceModal.times[i].end.length < 4 || this.presenceModal.times[i].end <= this.presenceModal.times[i].start ){
            valid = false;
          }
        }
      }
      if(!this.presenceModal.start && this.presenceModal.allDay){
        valid = false;
      }
  
      return valid;
    },

    /**
     * Remove extra presence (present or absent) from branch subcollection in firebase
     * @param type - type of time (present or absent)
     * @param id - id of the extra presence to remove
     */
    removeExtraPresence(type, id){
      db.collection("branches").doc(this.$store.state.activeBranchData.id).collection("qcareScheduleExceptions").doc(id).delete();
      if(type == 'present'){
        this.extraPresentSchedule = this.extraPresentSchedule.filter(item => item.id != id);
      }
      else{
        this.extraAbsentSchedule = this.extraAbsentSchedule.filter(item => item.id != id);
      }
      
    },

    /**
     * Format date
     * @param date - date to format
     * @param format - format to use
     * @returns formatted date
     */
    formatDate(date, format){
      return moment(date).locale('nl').format(format);
    }
  },

  computed: {
    extraAbsentScheduleFiltered(){
      return this.extraAbsentSchedule.filter(item => {
        return this.extraAbsentType == 'future' ? moment(item.end).isSameOrAfter(moment(), 'day') : moment(item.end).isBefore(moment(), 'day');
      }).sort((a,b)=>{ return a.start.localeCompare(b.start)});
    },
    extraPresentScheduleFiltered(){
      return this.extraPresentSchedule.filter(item => {
        return this.extraPresentType == 'future' ? moment(item.end).isSameOrAfter(moment(), 'day') : moment(item.end).isBefore(moment(), 'day');

      }).sort((a,b)=>{ return a.start.localeCompare(b.start)});
    },
    changed() {
      this.timeChanges
      return JSON.stringify(this.qcareSettings) !== JSON.stringify(this.qcareSettingsOriginal);
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }

};
</script>
<style scoped>
.row.row-even {
  background-color: #f9f9f9;
}
.row.row-odd {
  background-color: #ffffff;
}
</style>